// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"0e4f8f73","904":"e92720a2","954":"8386848d"}[chunkId] + ".chunk.css";
};